module.exports = __webpack_public_path__ + "fonts/subset-TitilliumWeb-SemiBold.8c154ea5.ttf";